// import React, { useCallback, useState } from "react";
// import { useDropzone } from "react-dropzone";

// const dropzoneStyle = {
//   flex: 1,
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   padding: "20px",
//   marginTop: "2rem",
//   borderWidth: "2px",
//   borderRadius: "2px",
//   borderColor: "#eeeeee",
//   borderStyle: "dashed",
//   backgroundColor: "#fafafa",
//   color: "#bdbdbd",
//   outline: "none",
//   transition: "border 0.24s ease-in-out",
//   cursor: "pointer",
// };

// const activeDropzoneStyle = {
//   borderColor: "#00adb5",
// };

// const ImagePreview = {
//   display: "flex",
//   maxWidth: "30%",
//   maxHeight: "30%",
//   margin: "auto",
//   borderRadius: "8px",
// };

// const hidden = {
//   display: "hidden",
// };

// const DropzoneComponent = () => {
//   const [files, setFiles] = useState([]);
//   const onDrop = useCallback((acceptedFiles) => {
//     setFiles(
//       acceptedFiles.map((file) =>
//         Object.assign(file, {
//           preview: URL.createObjectURL(file),
//         })
//       )
//     );
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: "image/*",
//     maxSize: 1024 * 1024 * 5,
//     maxFiles: 1,
//   });

//   const fileList = files.map((file) => (
//     <li key={file.name}>
//       <img style={ImagePreview} src={file.preview} alt={file.name} />
//     </li>
//   ));

//   return (
//     <>
//       <div className="col-lg-6"></div>
//       <div className="col-12">
//         <div className="row">
//           <div className="col-lg-6">
//             <div className="col-lg-12">
//               <div className="form-group mb-4">
//                 <div style={isDragActive ? { ...dropzoneStyle, ...activeDropzoneStyle } : dropzoneStyle} {...getRootProps()}>
//                   Drop your files here or <span className="text-green">browse</span>
//                   <br />
//                   <span className="text-grey fs-13 " style={...hidden}> Maximum size: 50MB</span>
//                   <input {...getInputProps()} />
//                   <ul>{fileList}</ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// // export default DropzoneComponent;
// import React, { useState } from "react";
// import { useDropzone } from "react-dropzone";
// import "./Atest.css";

// const ImageUpload = () => {
//   const [image, setImage] = useState(null);

//   const onDrop = (acceptedFiles) => {
//     const file = acceptedFiles[0];
//     const reader = new FileReader();

//     reader.onload = () => {
//       setImage(reader.result);
//     };

//     reader.readAsDataURL(file);
//   };

//   const { getRootProps, getInputProps } = useDropzone({ onDrop });

//   return (
//     <div className="image-upload-container">
//       {image ? (
//         <div className="image-preview-container">
//           <img src={image} alt="Uploaded" className="image-preview" />
//           <div className="text-overlay">Your logo</div>
//         </div>
//       ) : (
//         <div {...getRootProps()} className="dropzone">
//           <input {...getInputProps()} />
//           <p>Drag & drop an image here, or click to select one</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ImageUpload;

// import React, { useState } from "react";

// function App() {
//   const [isVisible, setIsVisible] = useState(false);

//   const toggleVisibility = () => {
//     setIsVisible(!isVisible);
//   };

//   return (
//     <div className="App">
//       <span onClick={toggleVisibility}>{isVisible ? <i className="bi bi-toggle-on"></i> : <i className="bi bi-toggle-off"></i>}</span>
//       {isVisible && (
//         <textarea rows="4" cols="50">
//           This is the text area.
//         </textarea>
//       )}
//     </div>
//   );
// }

// export default App;

// import React, { useRef } from "react";

// function App() {
//   const divRef = useRef(null);

//   const copyToClipboard = () => {
//     const textToCopy = divRef.current.innerText;
//     navigator.clipboard
//       .writeText(textToCopy)
//       .then(() => {
//         console.log("Text copied to clipboard");
//       })
//       .catch((err) => {
//         console.error("Error copying text: ", err);
//       });
//   };

//   return (
//     <div>
//       <div ref={divRef}>
//         Text to be copied<i className="bi bi-clipboard2"></i>
//       </div>
//       <button onClick={copyToClipboard}>Copy to Clipboard</button>
//     </div>
//   );
// }

// export default App;

// import React, { Component } from "react";
// import { EditorState, convertToRaw } from "draft-js";
// import { Editor } from "react-draft-wysiwyg";
// import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";

// class EditorConvertToHTML extends Component {
//   state = {
//     editorState: EditorState.createEmpty(),
//   };

//   onEditorStateChange: Function = (editorState) => {
//     this.setState({
//       editorState,
//     });
//   };

//   render() {
//     const { editorState } = this.state;
//     return (
//       <div>
//         <Editor editorState={editorState} wrapperClassName="demo-wrapper" editorClassName="demo-editor" onEditorStateChange={this.onEditorStateChange} />
//         <textarea disabled value={draftToHtml(convertToRaw(editorState.getCurrentContent()))} />
//       </div>
//     );
//   }
// }

// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const generateToken = async (username, password) => {
//   const url = "https://user.the-capacity.com/users/generate-token"; // Replace with your API endpoint
//   const credentials = {
//     username: username,
//     password: password,
//   };

//   try {
//     const response = await fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(credentials),
//     });

//     if (!response.ok) {
//       throw new Error("Failed to generate token");
//     }

//     const data = await response.json();
//     const token = data.token; // Assuming the token is returned as 'token' in the response

//     console.log(JSON.stringify(credentials));
//     return token;
//   } catch (error) {
//     console.error("Error generating token:", error);
//     return null;
//   }
// };

// const username = "akshay.singh@irbureau.com";
// const password = "irb1234";

// generateToken(username, password).then((token) => {
//   if (token) {
//     console.log("Token:", token);
//     // Proceed with using the token as needed
//   } else {
//     console.error("Failed to generate token");
//   }
// });

// export default generateToken;

// import { ColorPicker, useColor } from "react-color-palette";
// import "react-color-palette/css";

// function Atest() {
//   const [color, setColor] = useColor("#561ecb");

//   return <ColorPicker color={color} onChange={setColor} />;
// }

// Lazy load....................................................................................
// export default Atest;

// import React, { useEffect, useState, useRef, useCallback } from "react";
// import axios from "axios";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Divider } from "@mui/material";

// function App() {
//   const [countries, setCountries] = useState([]);
//   const [page, setPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const observer = useRef();

//   const fetchCountries = async (page) => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`https://user.the-capacity.com/users/country?page=${page}&limit=10`);
//       setCountries((prevCountries) => [...prevCountries, ...response.data]);
//       if (response.data.length < 10) {
//         setHasMore(false);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchCountries(page);
//   }, [page]);

//   const lastCountryElementRef = useCallback(
//     (node) => {
//       if (loading) return;
//       if (observer.current) observer.current.disconnect();
//       observer.current = new IntersectionObserver((entries) => {
//         if (entries[0].isIntersecting && hasMore) {
//           setPage((prevPage) => prevPage + 1);
//         }
//       });
//       if (node) observer.current.observe(node);
//     },
//     [loading, hasMore]
//   );

//   return (
//     <TableContainer component={Paper}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell>Country Name</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {countries.slice(0, 10).map((country, index) => {
//             if (countries.length === index + 1) {
//               return (
//                 <TableRow key={index} ref={lastCountryElementRef}>
//                   <TableCell>{country.countryName}"test"</TableCell>
//                 </TableRow>
//               );
//             } else {
//               return (
//                 <TableRow key={index}>
//                   <TableCell>{country.countryName}</TableCell>
//                 </TableRow>
//               );
//             }
//           })}
//           {loading && (
//             <TableRow>
//               <TableCell>
//                 <CircularProgress />
//               </TableCell>
//             </TableRow>
//           )}
//           {!loading && hasMore && (
//             <TableRow>
//               <TableCell>
//                 <Divider>Loading more...</Divider>
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// }

// export default App;





// import React, { useState } from "react";
// import { useDropzone } from "react-dropzone";

// const CSVUploader = () => {
//   const [csv, setCsv] = useState(null);
//   const [alerts, setAlerts] = useState([]);

//   const onDrop = (acceptedFiles) => {
//     if (acceptedFiles.length > 0 && acceptedFiles[0].type === "text/csv") {
//       const file = acceptedFiles[0];
//       validateCSV(file)
//         .then(() => {
//           setCsv(file);
//         })
//         .catch((error) => {
//           setAlerts([{ variant: "danger", heading: error }]);
//         });
//     } else {
//       setAlerts([{ variant: "danger", heading: "Please select a valid CSV file." }]);
//     }
//   };

//   const validateCSV = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => {
//         const rows = reader.result.split(/\r?\n/); // Handles both Unix (\n) and Windows (\r\n) line endings
//         const headers = rows[0].split(",").map((header) => header.trim()); // Trims whitespace from headers

//         console.log("Headers found in file:", headers); // Log the headers for debugging

//         const requiredHeaders = ["QuestionTypeID", "QuestionCode", "QuestionTitle", "Question", "AnswerCode", "Answer"];

//         const missingHeaders = requiredHeaders.filter((header) => !headers.includes(header));

//         if (missingHeaders.length > 0) {
//           reject(`Missing required headers: ${missingHeaders.join(", ")}`);
//         } else {
//           resolve();
//           console.log("CSV validation successful");
//         }
//       };
//       reader.readAsText(file);
//     });
//   };

//   const { getRootProps, getInputProps } = useDropzone({ onDrop });

//   return (
//     <div {...getRootProps()} className="dropzone">
//       <input {...getInputProps()} />
//       <p>Drag 'n' drop a CSV file here, or click to select one</p>
//       {alerts.map((alert, index) => (
//         <div key={index} className={`alert alert-${alert.variant}`}>
//           {alert.heading}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default CSVUploader;

// import React, { useState } from 'react';
// import { MultiRootEditor, Bold, Essentials, Italic, Paragraph, Underline, Strikethrough, Link, List, BlockQuote, Code } from 'ckeditor5';
// import { useMultiRootEditor } from '@ckeditor/ckeditor5-react';
// import 'ckeditor5/ckeditor5.css';


// const App = () => {
//     const editorProps = {
//         editor: MultiRootEditor,
//         data: {
//             intro: '<input>React multi-root editor</input>',
//             content1: '<p>Editable Content 1</p>',
//             content2: '<p>Editable Content 2</p>',
//             content3: '<p>Editable Content 3</p>',
//             content4: '<p>Editable Content 4</p>',
//             content5: '<p>Editable Content 5</p>'
//         },
//         config: {
//             plugins: [Essentials, Bold, Italic, Underline, Strikethrough, Link, List, BlockQuote, Code, Paragraph],
//             toolbar: {
//                 items: [


//                     'bold',
//                     'italic',
//                     'underline',
//                     'strikethrough',
//                     'link',
//                     'bulletedList',
//                     'numberedList',
//                     'blockQuote',
//                     'code'
//                 ]
//             },
//         }
//     };

//     const {
//         toolbarElement,
//         editableElements,
//     } = useMultiRootEditor(editorProps);
//     console.log("edit", editableElements)

//     return (
//         <div className="container-fluid mt-5 d-block">
//             <div >  <h2 className="text-center mb-4">Using CKEditor 5 Multi-Root Editor in React</h2></div>

//             <div className="p-4 bg-light rounded shadow-sm w-100">
//                 {toolbarElement}

//                 <div className="mt-4">

//                     {/* {editableElements.map((element, index) => (
//                         <div key={index} className="mb-4">
//                             <h5>Editable Content {index + 1}</h5>
//                             {element}
//                         </div>
//                     ))} */}
//                     <div> <label htmlFor="">Main</label>
//                         {editableElements[0]}</div>
//                     {editableElements[1]}
//                     {editableElements[2]}
//                     {editableElements[3]}
//                     {editableElements[4]}
//                     {editableElements[5]}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default App;




// import React, { useState } from 'react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// const CustomEditor = () => {
//     const [editorData, setEditorData] = useState({
//         title: '',
//         question: '',
//         answers: [''] // Start with one answer field
//     });

//     const handleEditorChange = (key, index = null) => (event, editor) => {
//         const data = editor.getData();

//         if (key === 'answers') {
//             const newAnswers = [...editorData.answers];
//             newAnswers[index] = data;
//             setEditorData({ ...editorData, answers: newAnswers });
//         } else {
//             setEditorData({ ...editorData, [key]: data });
//         }
//     };

//     const addAnswerField = () => {
//         setEditorData({
//             ...editorData,
//             answers: [...editorData.answers, '']
//         });
//     };

//     const removeAnswerField = (index) => {
//         const newAnswers = editorData.answers.filter((_, i) => i !== index);
//         setEditorData({ ...editorData, answers: newAnswers });
//     };

//     return (
//         <div className='row'>
//             <div className="editor-section">
//                 <label>Title:</label>
//                 <CKEditor
//                     editor={ClassicEditor}
//                     data={editorData.title}
//                     onChange={handleEditorChange('title')}
//                 />
//             </div>

//             <div className="editor-section">
//                 <label>Question:</label>
//                 <CKEditor
//                     editor={ClassicEditor}
//                     data={editorData.question}
//                     onChange={handleEditorChange('question')}
//                 />
//             </div>

//             <div className="editor-section">
//                 <label>Answers:</label>
//                 {editorData.answers.map((answer, index) => (
//                     <div key={index} className="answer-section">
//                         <CKEditor
//                             editor={ClassicEditor}
//                             data={answer}
//                             onChange={handleEditorChange('answers', index)}
//                         />
//                         <button onClick={() => removeAnswerField(index)}>Remove Answer</button>
//                     </div>
//                 ))}
//             </div>

//             <button onClick={addAnswerField}>Add Answer</button>
//         </div>
//     );
// };

// export default CustomEditor;






// import React, { useState } from 'react';
// import { MultiRootEditor, Bold, Essentials, Italic, Paragraph, Underline, Strikethrough, Link, List, BlockQuote, Code } from 'ckeditor5';
// import { useMultiRootEditor } from '@ckeditor/ckeditor5-react';


// const App = () => {
//     const defaultRoots = ['intro', 'content1', 'content2', 'content3', 'content4', 'content5'];
//     const answerRoots = ['intro', 'content3', 'content4', 'content5'];
//     const textRoots = ['intro', 'content3', 'content4', 'content5', 'contnet6', 'content7', 'content8'];
//     const [editorRoots, setEditorRoots] = useState(defaultRoots);

//     const editorProps = {
//         editor: MultiRootEditor,
//         data: editorRoots.reduce((data, root, index) => ({
//             ...data,
//             [root]: `<p>Editable Content ${index + 1}</p>`
//         }), {}),
//         config: {
//             plugins: [Essentials, Bold, Italic, Underline, Strikethrough, Link, List, BlockQuote, Code, Paragraph],
//             toolbar: {
//                 items: [
//                     'bold', 'italic', 'underline', 'strikethrough', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'code'
//                 ]
//             },
//         }
//     };

//     const { toolbarElement, editableElements, editor } = useMultiRootEditor(editorProps);

//     const addMoreFields = () => {
//         const newRoot = `content${editorRoots.length + 1}`;
//         setEditorRoots([...editorRoots, newRoot]);

//         // Add a new root dynamically
//         editor.addRoot(newRoot, { data: '<p>New Editable Content</p>' });
//     };

//     const removeField = (root) => {
//         // Remove root from the editor
//         editor.detachRoot(root);

//         // Remove root from the state
//         setEditorRoots(editorRoots.filter(r => r !== root));
//     };

//     const handleSubmit = () => {
//         const formData = {};

//         // Collect data from all editor roots
//         editorRoots.forEach(root => {
//             formData[root] = editor.getData({ rootName: root });
//         });

//         // Log the form data (you can send it to an API or process it as needed)
//         console.log('Submitted Data:', formData);
//         alert('Data submitted successfully! Check the console for details.');
//     };

//     console.log("editor", editorRoots)

//     return (
//         <div className="container-fluid mt-5 d-block">
//             <div>
//                 <h2 className="text-center mb-4">Using CKEditor 5 Multi-Root Editor in React</h2>
//             </div>

//             <div className="p-4 bg-light rounded shadow-sm w-100">
//                 {toolbarElement}

//                 <div className="mt-4">

//                     {editorRoots.map((root, index) => (
//                         <div key={index} className={`mb-3 editor_${index}`} >
//                             <label htmlFor="">{`Root ${index + 1}`}</label>
//                             {editableElements[index]}

//                             {/* Show Remove button only for dynamically added fields */}
//                             {!defaultRoots.includes(root) && (
//                                 <button
//                                     className="btn btn-danger btn-sm ml-2"
//                                     onClick={() => removeField(root)}
//                                 >
//                                     Remove
//                                 </button>
//                             )}
//                         </div>
//                     ))}
//                 </div>

//                 <button className="btn btn-primary mt-3" onClick={addMoreFields} >
//                     Add More
//                 </button>
//                 <button className="btn btn-primary mt-3" onClick={() => setEditorRoots(answerRoots)} >
//                     next
//                 </button> <button className="btn btn-primary mt-3" onClick={() => setEditorRoots(textRoots)} >
//                     next 2
//                 </button>

//                 <button className="btn btn-success mt-3 ml-2" onClick={handleSubmit}>
//                     Submit
//                 </button>
//             </div>


//         </div >
//     );
// };

// export default App;




// import React, { useState } from 'react';
// import { MultiRootEditor, Bold, Essentials, Italic, Paragraph, Underline, Strikethrough, Link, List, BlockQuote, Code } from 'ckeditor5';
// import { useMultiRootEditor } from '@ckeditor/ckeditor5-react';
// import 'ckeditor5/ckeditor5.css';

// const App = () => {
//     const defaultRoots = ['intro', 'content1', 'content2', 'content3', 'content4', 'content5'];
//     const [editorRoots, setEditorRoots] = useState(defaultRoots);
//     const [moreFieldsRoots, setMoreFieldsRoots] = useState([]);
//     const [anotherFieldsRoots, setAnotherFieldsRoots] = useState([]);

//     const editorProps = {
//         editor: MultiRootEditor,
//         data: editorRoots.reduce((data, root, index) => ({
//             ...data,
//             [root]: `<p>Editable Content ${index + 1}</p>`
//         }), {}),
//         config: {
//             plugins: [Essentials, Bold, Italic, Underline, Strikethrough, Link, List, BlockQuote, Code, Paragraph],
//             toolbar: {
//                 items: [
//                     'bold',
//                     'italic',
//                     'underline',
//                     'strikethrough',
//                     'link',
//                     'bulletedList',
//                     'numberedList',
//                     'blockQuote',
//                     'code'
//                 ]
//             },
// `<p placeholder="Type your answer here..."
//         }
//     };

//     const { toolbarElement, editableElements, editor } = useMultiRootEditor(editorProps);

//     const addMoreFields = () => {
//         const newRoot = `moreField${moreFieldsRoots.length + 1}`;
//         editor.addRoot(newRoot, { data: '<p>New Field</p>' });
//         setMoreFieldsRoots([...moreFieldsRoots, newRoot]);
//     };

//     const addAnotherField = () => {
//         const newRoot = `anotherField${anotherFieldsRoots.length + 1}`;
//         editor.addRoot(newRoot, { data: '<p>Another New Field</p>' });
//         setAnotherFieldsRoots([...anotherFieldsRoots, newRoot]);
//     };

//     const renderMoreFields = () => {
//         return moreFieldsRoots.map((root, index) => (
//             <div key={index} className={`mb-3 editor_${index}`}>
//                 <label htmlFor="">{root}</label>
//                 {editableElements[editorRoots.length + index]}
//                 <button className="btn btn-danger ml-2" onClick={() => deleteField(root)}>Delete</button>
//             </div>
//         ));
//     };

//     const renderAnotherFields = () => {
//         return anotherFieldsRoots.map((root, index) => (
//             <div key={index} className={`mb-3 editor_${index}`}>
//                 <label htmlFor="">{root}</label>
//                 {editableElements[editorRoots.length + moreFieldsRoots.length + index]}
//                 <button className="btn btn-danger ml-2" onClick={() => deleteField(root)}>Delete</button>
//             </div>
//         ));
//     };

//     const deleteField = (rootName) => {
//         editor.detachRoot(rootName);
//         if (moreFieldsRoots.includes(rootName)) {
//             setMoreFieldsRoots(moreFieldsRoots.filter((root) => root !== rootName));
//         } else if (anotherFieldsRoots.includes(rootName)) {
//             setAnotherFieldsRoots(anotherFieldsRoots.filter((root) => root !== rootName));
//         }
//     };

//     return (
//         <div className="container-fluid mt-5 d-block">
//             <div>
//                 <h2 className="text-center mb-4">Using CKEditor 5 Multi-Root Editor in React</h2>
//             </div>

//             <div className="p-4 bg-light rounded shadow-sm w-100">
//                 {toolbarElement}

//                 <div className="mb-3 editor_0">
//                     <label htmlFor="">Intro</label>
//                     {editableElements[0]}
//                 </div>

//                 <div className="mb-3 editor_1">
//                     <label htmlFor="">Content 1</label>
//                     {editableElements[1]}
//                 </div>

//                 <div className="mb-3 editor_2">
//                     <label htmlFor="">Content 2</label>
//                     {editableElements[2]}
//                 </div>

//                 <div className="mb-3 editor_3">
//                     <label htmlFor="">Content 3</label>
//                     {editableElements[3]}
//                     {renderMoreFields()}
//                 </div>

//                 <div className="mb-3 editor_4">
//                     <label htmlFor="">Content 4</label>
//                     {editableElements[4]}
//                     {renderAnotherFields()}
//                 </div>

//                 <div className="mb-3 editor_5">
//                     <label htmlFor="">Content 5</label>
//                     {editableElements[5]}
//                 </div>

//                 <button className="btn btn-primary mt-3" onClick={addMoreFields}>
//                     Add More Fields
//                 </button>

//                 <button className="btn btn-success mt-3 ml-2" onClick={addAnotherField}>
//                     Add Another Field
//                 </button>

//                 <button className="btn btn-success mt-3 ml-2" onClick={() => {
//                     const formData = {};
//                     editorRoots.forEach(root => {
//                         formData[root] = editor.getData({ rootName: root });
//                     });
//                     console.log('Submitted Data:', formData);
//                     alert('Data submitted successfully! Check the console for details.');
//                 }}>
//                     Submit
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default App;

// import React from 'react'
// import MaterialTable from "@material-table/core";

// const App = () => {

//     return (

//         <div className="column p-3">
//             <div className="col-lg-12">
//                 <div className="card px-3 border-light-subtle">
//                     <MaterialTable
//                         title=""
//                         style={{ padding: 12, paddingBottom: 0, boxShadow: "none", fontWeight: "bold", fontSize: "12px" }}
//                         columns={[
//                             { title: "S.No", field: "sno", width: "10%" },

//                             { title: "Type", field: "type" },
//                             { title: "Question statement", field: "ques", width: "50%" },
//                             { title: "Question code", field: "qcode" },
//                         ]}
//                         data={[
//                             { sno: "1", type: "Multi-select", ques: "What's your favorite childhood memory?", qcode: 12422432 },
//                             { sno: "2", type: "One-line text", ques: "What's your favorite movie and why?", qcode: 12422432 },
//                             { sno: "3", type: "Dropdown", ques: "What was your favorite subject in school?", qcode: 12422432 },
//                             { sno: "4", type: "Single-select", ques: "What's your favorite family holiday tradition?", qcode: 12422432 },
//                         ]}
//                         options={{
//                             headerStyle: {
//                                 backgroundColor: "rgb(240,240,240)",
//                                 padding: "8px 16px",
//                                 color: "#6B7280",
//                                 fontSize: "12px",
//                             },
//                             actionsColumnIndex: -1,
//                             searchFieldAlignment: "left",
//                             paginationAlignment: "left",
//                             sorting: true,
//                             searchFieldStyle: {
//                                 border: "0.5px solid #6EE7B7",
//                                 borderRadius: "4px",
//                                 padding: "6px 12px",
//                                 fontSize: "14px",
//                                 lineHeight: "1.5",
//                                 color: "#333",
//                                 backgroundColor: "#fff",
//                                 boxSizing: "border-box",
//                                 width: "25vw",
//                                 marginLeft: "-2.9vw",
//                             },
//                         }}
//                         localization={{
//                             header: {
//                                 actions: "Delete",
//                             },
//                         }}
//                         actions={[
//                             {
//                                 icon: () => (
//                                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
//                                         <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
//                                     </svg>
//                                 ),
//                                 tooltip: "delete",
//                                 onClick: (event, rowData) => alert("You deleted " + rowData.type),
//                             },
//                         ]}
//                     />
//                 </div>
//             </div>
//         </div>)
// }
// export default App;



// import React, { useState, useEffect } from 'react';

// function Atest() {

//     const questions = [
//         { id: 1, text: "Q1" },
//         { id: 2, text: "Q2" },
//         { id: 3, text: "Q3" }
//     ];

//     const answers = [
//         { id: 1, text: "A1" },
//         { id: 2, text: "A2" },
//         { id: 3, text: "A3" },
//         { id: 4, text: "A4" }
//     ];

//     const [logicString, setLogicString] = useState(''); // Initialize blank logic string
//     const [logicConditions, setLogicConditions] = useState([
//         { question: "", is: "=", answer: "", nestlogic: "" } // Initialize without nesting logic
//     ]);

//     // Function to handle adding new logic
//     const addLogicCondition = () => {
//         setLogicConditions([...logicConditions, { question: "", is: "=", answer: "", nestlogic: "||" }]);
//     };

//     // Function to handle changes in the form inputs
//     const handleChange = (index, field, value) => {
//         const newLogicConditions = [...logicConditions];
//         newLogicConditions[index][field] = value;
//         setLogicConditions(newLogicConditions);
//     };

//     // Function to update the logic string for the textarea
//     const updateLogicString = () => {
//         if (logicConditions.length === 0 || !logicConditions[0].question) {
//             setLogicString(''); // Keep it empty if no conditions are present
//             return;
//         }

//         const logicText = logicConditions.map((logic, index) => {
//             const question = logic.question ? `${logic.question}` : "Question: Not selected";
//             const isCondition = logic.is ? ` ${logic.is} ` : "";
//             const answer = logic.answer ? `${logic.answer}` : "Answer: Not selected";

//             const conditionString = `${question}${isCondition}${answer}`;

//             // Add nesting logic if this is not the last condition
//             if (index < logicConditions.length - 1) {
//                 const nestLogic = logic.nestlogic ? ` ${logic.nestlogic} ` : "";
//                 return `${conditionString}\n${nestLogic}`;
//             }

//             return conditionString;
//         }).join("\n");

//         setLogicString(logicText);
//     };

//     // Use effect to update the logic string whenever logicConditions change
//     useEffect(() => {
//         updateLogicString();
//     }, [logicConditions]);

//     return (
//         <div>
//             <div className="col-lg-2 m-3">
//                 <button className="btn btn-success w-100 mx-0" data-bs-toggle="modal" data-bs-target="#logicSetup">
//                     Logic Setup
//                 </button>
//             </div>
//             <div className="modal fade" id="logicSetup" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
//                 <div className="modal-dialog modal-dialog-centered modal-lg">
//                     <div className="modal-content p-2">
//                         <div className="modal-header d-flex p-0 border-0">
//                             <h1 className="modal-title text-black fw-bold fs-4 mt-2 px-3" id="exampleModalLabel">
//                                 Logic Condition Setup
//                             </h1>
//                         </div>

//                         <div className="modal-body">
//                             {logicConditions.map((logic, index) => (
//                                 <div key={index}>
//                                     {/* If Condition */}
//                                     <div className="row align-items-center my-3">
//                                         <div className="col-lg-1">
//                                             <label className="form-label" htmlFor={`if-select-${index}`}>
//                                                 If
//                                             </label>
//                                         </div>
//                                         <div className="col-lg-8">
//                                             <select
//                                                 className="form-select text-center"
//                                                 id={`if-select-${index}`}
//                                                 value={logic.question}
//                                                 onChange={(e) => handleChange(index, 'question', e.target.value)}
//                                             >
//                                                 <option value="">Select Question</option>
//                                                 {questions.map((question) => (
//                                                     <option key={question.id} value={question.text}>
//                                                         {question.text}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-lg-2">
//                                             <select
//                                                 className="form-select text-center"
//                                                 id={`is-select-${index}`}
//                                                 value={logic.is}
//                                                 onChange={(e) => handleChange(index, 'is', e.target.value)}
//                                             >
//                                                 <option value="=">Is</option>
//                                                 <option value="!=">Is not</option>
//                                             </select>
//                                         </div>
//                                     </div>

//                                     {/* Answer Condition */}
//                                     <div className="row align-items-center">
//                                         <div className="col-lg-1">
//                                             <label className="form-label" htmlFor={`ans-select-${index}`}>
//                                                 Ans
//                                             </label>
//                                         </div>
//                                         <div className="col-lg-8">
//                                             <select
//                                                 className="form-select text-center"
//                                                 id={`ans-select-${index}`}
//                                                 value={logic.answer}
//                                                 onChange={(e) => handleChange(index, 'answer', e.target.value)}
//                                             >
//                                                 <option value="">None selected</option>
//                                                 {answers.map((answer) => (
//                                                     <option key={answer.id} value={answer.text}>
//                                                         {answer.text}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                     </div>

//                                     {/* Nesting logic */}
//                                     {index < logicConditions.length - 1 && (
//                                         <div className="d-flex align-items-center justify-content-center my-3">
//                                             <hr className="flex-grow-1 " />
//                                             <div className="d-flex align-items-center mx-2">
//                                                 <span className=" text-nowrap mx-2">Nest Question With</span>
//                                                 <select
//                                                     className="form-select form-select-sm"
//                                                     value={logic.nestlogic}
//                                                     onChange={(e) => handleChange(index, 'nestlogic', e.target.value)}
//                                                 >
//                                                     <option value="||">Or</option>
//                                                     <option value="&&">And</option>
//                                                 </select>
//                                             </div>
//                                             <hr className="flex-grow-1 " />
//                                         </div>
//                                     )}
//                                 </div>
//                             ))}

//                             {/* Button to Add More Logic */}
//                             <div className="d-flex justify-content-center my-3">
//                                 <button className="btn btn-success" onClick={addLogicCondition}>
//                                     Add More Logic
//                                 </button>
//                             </div>

//                             {/* Textarea for Logic String */}
//                             <div className="form-control">
//                                 <label htmlFor="" className="form-label text-secondary">
//                                     Show Row Code
//                                 </label>
//                             </div>

//                             <div>
//                                 <textarea
//                                     name=""
//                                     className="form-control"
//                                     rows="15"
//                                     value={logicString} // Set the logic string in the textarea
//                                     readOnly
//                                 />
//                             </div>
//                         </div>

//                         {/* Save Button */}
//                         <div className="d-flex justify-content-end">
//                             <button className="btn btn-success" data-bs-dismiss="modal">
//                                 Save Logic
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Atest;


import React, { useState } from 'react';

const Atest = () => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [data, setData] = useState([
        { label: 'Device', icon: '', linebr: false },
        { label: 'Age', icon: 'dropdown', linebr: false },
        { label: 'What is your gender?', icon: 'radio', linebr: true },
        { label: 'Employment Status', icon: 'multi', linebr: false },
        { label: 'Work Experience', icon: 'rating', linebr: false },
        { label: 'Company Size', icon: 'range', linebr: true },
        { label: 'Company revenue', icon: 'amount', linebr: false },
    ]);

    // Handle list item selection
    const handleClick = (index) => {
        setSelectedIndex(index);
    };

    // const [showAllLanguages, setShowAllLanguages] = useState(false);

    // // List of languages
    // const languages = [
    //     { id: "flexCheckEnglish", label: "English" },
    //     { id: "flexCheckHindi", label: "Hindi" },
    //     { id: "flexCheckGerman", label: "German" },
    //     { id: "flexCheckKannada", label: "Kannada" },
    //     { id: "flexCheckFrench", label: "French" },
    //     { id: "flexCheckItalian", label: "Italian" },
    //     { id: "flexCheckMandarin", label: "Mandarin" },
    // ];

    // // Number of languages to show by default
    // const defaultLanguagesToShow = 4;

    // // Function to toggle the visibility of all languages
    // const toggleShowAllLanguages = () => {
    //     setShowAllLanguages(!showAllLanguages);
    // };

    //     // Toggle the 'linebr' value for the selected item
    const handlePageBreak = () => {
        alert(selectedIndex)
        if (selectedIndex !== null) { // Ensure an item is selected
            setData(prevData => {
                const newData = [...prevData];
                newData[selectedIndex].linebr = !newData[selectedIndex].linebr;
                // alert(newData[selectedIndex].linebr)
                return newData;
            });
        }
    };

    return (
        <div>
            <div className="card border-light-subtle">
                <div className="p-4">
                    <div className="sidebar-section">
                        <div className="common_form p-2 mb-9">
                            <label className=" py-2 bg-heading text-center fw-bold ">Question Statement</label>
                        </div>

                        <ul className="list-group list-group-flush">
                            {data.map((item, index) => (
                                <li key={index}
                                    className={`list-group-item d-flex align-items-center  ${selectedIndex === index ? 'border border-success bg-light border-opacity-25' : ''}`}
                                    onClick={() => handleClick(index)}
                                    style={{ borderBottom: item.linebr ? "2px solid lightgray" : "none" }}
                                >
                                    <div className="col-lg-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 16 16">
                                            <path fill="currentColor" fillRule="evenodd" d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                                            />
                                        </svg>
                                    </div>

                                    <div className="col-lg-10">
                                        {(() => {
                                            if (item.icon === "dropdown") {
                                                return (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24" className='mx-2'>
                                                        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                                            <rect width="18" height="18" x="3" y="3" rx="2" />
                                                            <path d="m16 10l-4 4l-4-4" />
                                                        </g>
                                                    </svg>
                                                );
                                            } else if (item.icon === "radio") {
                                                return <i className="bi bi-stop-circle mx-2"></i>;
                                            } else if (item.icon === "multi") {
                                                return (<i className="bi bi-check-square mx-2"></i>);
                                            } else if (item.icon === "rating") {
                                                return (<i className="bi bi-star-half mx-2"></i>);
                                            } else if (item.icon === "range" || item.icon === "amount") {
                                                return (<i className="bi bi-check-square mx-2"></i>);
                                            } else {
                                                return (<span className="mx-2"></span>);
                                            }
                                        })()}
                                        <label>{item.label}</label>
                                    </div>

                                    {selectedIndex === index && (
                                        <div className="col-lg-1 dropdown">
                                            <i className="bi bi-three-dots-vertical" role="button" data-bs-toggle="dropdown" aria-expanded="false"></i>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <a className="dropdown-item" href="#">
                                                        Delete Question
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item" href="#">
                                                        Copy Question
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>

                        <div className="mt-3">
                            <button className="btn btn-success w-100" onClick={handlePageBreak}>
                                Page break
                            </button>
                            <button className="btn btn-success w-100 mt-2">
                                + Add new question
                            </button>
                        </div>
                    </div>
                </div>
            </div>




            {/* // ................................................................................ */}
            {/* 
            <hr />

            <div className="col-lg-3 property-item text-secondary ms-2 me-2">
                <div >
                    <label className="me-2 text-secondary mb-0 fs-13">Language</label>

                    <i
                        className="bi bi-caret-down-fill text-secondary"
                        role="button"

                        style={{ cursor: "pointer" }}
                    ></i> */}

            {/* <i
                        className="bi bi-caret-down-fill text-secondary"
                        onClick={toggleDropdown2}
                        role="button"
                        aria-expanded={isDropdownVisible2}
                        style={{ cursor: "pointer" }}
                      ></i> */}
            {/* </div> */}

            {/* <div className="mt-2" style={{ zIndex: 2000, minWidth: "140px" }}>
                    <div className="row g-1">
                        {languages
                            .slice(0, showAllLanguages ? languages.length : defaultLanguagesToShow)
                            .map((language) => (
                                <div className="col-6 d-flex align-items-center" key={language.id}>
                                    <input
                                        className="form-check-input me-1"
                                        type="checkbox"
                                        id={language.id}
                                        style={{ transform: "scale(1)" }}
                                    />
                                    <label htmlFor={language.id} className="text-secondary fs-12">
                                        {language.label}
                                    </label>
                                </div>
                            ))} */}
            {/* <div className="col-6 d-flex align-items-center">
                            <input className="form-check-input me-1" type="checkbox" id="flexCheckHindi" style={{ transform: "scale(1)" }} />
                            <label htmlFor="flexCheckHindi" className="text-secondary fs-12">
                                Hindi
                            </label>
                        </div>

                        <div className="col-6 d-flex align-items-center">
                            <input className="form-check-input me-1" type="checkbox" id="flexCheckGerman" style={{ transform: "scale(1)" }} />
                            <label htmlFor="flexCheckGerman" className="text-secondary fs-12">
                                German
                            </label>
                        </div>

                        <div className="col-6 d-flex align-items-center">
                            <input className="form-check-input me-1" type="checkbox" id="flexCheckKannada" style={{ transform: "scale(1)" }} />
                            <label htmlFor="flexCheckKannada" className="text-secondary fs-12">
                                Kannada
                            </label>
                        </div>

                        <div className="col-6 d-flex align-items-center">
                            <input className="form-check-input me-1" type="checkbox" id="flexCheckFrench" style={{ transform: "scale(1)" }} />
                            <label htmlFor="flexCheckFrench" className="text-secondary fs-12">
                                French
                            </label>
                        </div>

                        <div className="col-6 d-flex align-items-center">
                            <input className="form-check-input me-1" type="checkbox" id="flexCheckItalian" style={{ transform: "scale(1)" }} />
                            <label htmlFor="flexCheckItalian" className="text-secondary fs-12">
                                Italian
                            </label>
                        </div>

                        <div className="col-6 d-flex align-items-center">
                            <input className="form-check-input me-1" type="checkbox" id="flexCheckMandarin" style={{ transform: "scale(1)" }} />
                            <label htmlFor="flexCheckMandarin" className="text-secondary fs-12">
                                Mandarin
                            </label>
                        </div> */}


            {/* <div className="mt-2 col-lg-12">
                            <button
                                className="btn btn-success w-100"
                                style={{ padding: "2px 6px", borderRadius: "6px" }}
                                onClick={toggleShowAllLanguages}
                            >
                                {showAllLanguages ? "Show Less" : "View All Languages"}
                            </button>
                        </div> */}


            {/* </div> */}
            {/* </div> */}
            {/* </div> */}
        </div>
    );
};

export default Atest;


